export enum GlobalModule {
  CARE = "care",
  CAREERS = "careers",
}

export interface AuditLog {
  action: string;
  message: string;
  sender?: string;
  date: Date;
  admin?: string;
  record?: string;
}

export interface Breadcrumb {
  title: string;
  url: string;
}

export enum CommentMedium {
  CALL = "call",
}

export interface Comment {
  id?: string;
  medium?: CommentMedium;
  body: string;
  administrator?: {
    name: string;
  };
  createdAt?: Date;
  record?: string;
}

export interface CurrentUser {
  id: string;
}

export interface User {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
}

export interface Role {
  id: string;
  title: string;
  default: boolean;
  admin: boolean;
  userCount: number;
}

export enum ApprovalStatus {
  PENDING = "pending",
  COMPLETED = "completed",
  NOT_REQUIRED = "not_required",
}

export interface Approver {
  id: string;
  name: string;
}

export interface RejectedNotified {
  id: string;
  name: string;
}

export interface ApprovalPipeline {
  id: string;
  title: string;
  versions: ApprovalPipelineVersion[];
}

export interface ApprovalPipelineVersion {
  id: string;
  version: number;
  publishedAt: Date;
  active: boolean;
  steps?: ApprovalStep[];
}

export interface ApprovalStep {
  id: string;
  _destroy?: boolean;
  unsaved?: boolean;
  index: number;
  title: string;
  description: string;
  approvalInstructions: string;
  approvers: Approver[];
  rejectedNotified: RejectedNotified[];
}

export enum TaskType {
  UNKNOWN = "unknown",
}

export interface TaskAssignment {
  name: string;
}

export interface Task {
  id: string;
  taskType: TaskType;
  url?: string;
  completed: boolean;
  users: TaskAssignment[];
}

export enum RiskLevel {
  VERY_LOW = "very-low",
  LOW = "low",
  LOW_MEDIUM = "low-medium",
  MEDIUM_HIGH = "medium-high",
  HIGH = "high",
  VERY_HIGH = "very-high",
}

export enum FormCategory {
  Incident = "incident",
  IncidentFollowUp = "incident_follow_up",
  Welfare = "welfare",
  Medical = "medical",
  OnOffBoarding = "on_off_boarding",
  RoutineRecord = "routine_record",
  HomeRecord = "home_record",
  Positive = "positive",
  ThirdParty = "third_party",
  HomeThirdParty = "home_third_party",
  Internal = "internal",
  External = "external",
  Employee = "employee",
}

export interface FormSubmission {
  id: string;
  title: string;
  category: {
    key: FormCategory;
    title: string;
  };
  completed: boolean;
  unlocked: boolean;
  incidentLevel: number;
  approvalStatus: ApprovalStatus;
  createdAt: Date;
  updatedAt: Date;
  completedAt: Date;

  parents?: FormSubmission[];
  children?: FormSubmission[];
}
